/* src/app/ships/ship-contacts/ship-contacts.component.css */
.save-panel {
  margin-top: -10px;
  margin-right: -15px;
}
input.ng-invalid.ng-touched {
  border: 1px solid red;
}
span.has-error {
  display: block;
}
/*# sourceMappingURL=ship-contacts.component.css.map */
